import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  orderEligibilitiesMockNotEligibleToRefund,
  orderMockEligibleToRefund,
} from '../../../mock/data/index';
import {
  orderNotEligibleForRefundWarning,
} from '../../../mock/dictionaries/index';

/**
 * Mocks for already refunded order.
 */
export const notEligibleToRefundMock: MockMap = {
  retrieveOrder: [createMockData(orderMockEligibleToRefund)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockNotEligibleToRefund, [], [orderNotEligibleForRefundWarning])]
};
